export default __webpack_public_path__ + "static/media/OKCoin.4e6267c9.svg";